import React, { useCallback, useMemo, useState } from "react";
import { Box, Typography } from "@mui/material";

import { useI18n } from "../../../i18n/I18nContext";
import SearchMapSection from "../companies/SearchMapSection";
import HotelsTable from "../companies/Table";

export default function HotelsPage() {
    const { t } = useI18n();
    const [rows, setRows] = useState([]);

    const handleCompaniesChange = useCallback((companies) => {
        setRows(Array.isArray(companies) ? companies : []);
    }, []);

    const resultsLabel = useMemo(() => {
        return String(t("map.search.resultsLabel")).replace("{{count}}", String(rows.length));
    }, [t, rows.length]);

    return (
        <Box sx={{ p: { xs: 2, md: 3 } }}>
            <Typography variant="h4" component="h1" sx={{ mb: 3 }}>
                {t("hotels.title")}
            </Typography>

            <SearchMapSection defaultType="hotel" onCompaniesChange={handleCompaniesChange} />

            <Typography variant="h6" sx={{ mt: 3, mb: 1 }}>
                {resultsLabel}
            </Typography>

            <HotelsTable rows={rows} />
        </Box>
    );
}
